// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.skl-panel {
  padding: 20px 0;
}

.skl-card {
  margin-bottom: 24px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 24px;
}

.skl-card-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
}

.skl-card-actions,
.skl-footer-actions {
  display: flex;
  gap: 10px;
}

.skl-summary-block {
  margin-bottom: 20px;
}

.skl-field-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.skl-footer-actions {
  margin-top: 20px;
}

.skl-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.skl-stat-card {
  border: 1px solid #edf0f2;
  border-radius: 6px;
  padding: 18px;
}

@media (max-width: 991.98px) {
  .skl-field-row,
  .skl-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 767.98px) {
  .skl-card-header,
  .skl-card-actions,
  .skl-footer-actions {
    flex-wrap: wrap;
  }
  .skl-field-row,
  .skl-stats-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/modernization-readiness/modernization-readiness-skeleton/modernization-readiness-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE;;IAEE,gDAAA;EACF;AACF;AAEA;EACE;;;IAGE,eAAA;EAAF;EAGA;;IAEE,0BAAA;EADF;AACF","sourcesContent":[".skl-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.skl-panel {\n  padding: 20px 0;\n}\n\n.skl-card {\n  margin-bottom: 24px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 24px;\n}\n\n.skl-card-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.skl-card-actions,\n.skl-footer-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.skl-summary-block {\n  margin-bottom: 20px;\n}\n\n.skl-field-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.skl-footer-actions {\n  margin-top: 20px;\n}\n\n.skl-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.skl-stat-card {\n  border: 1px solid #edf0f2;\n  border-radius: 6px;\n  padding: 18px;\n}\n\n@media (max-width: 991.98px) {\n  .skl-field-row,\n  .skl-stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 767.98px) {\n  .skl-card-header,\n  .skl-card-actions,\n  .skl-footer-actions {\n    flex-wrap: wrap;\n  }\n\n  .skl-field-row,\n  .skl-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
